import React from 'react';

type Props = {
  testID?: string;
};

export const DashboardOrganizationHome: React.FC<Props> = ({ testID = 'DashboardOrganizationHome' }) => {
  return <div data-testid={testID} className=""></div>;
};
